import {makeAutoObservable} from 'mobx';
import {api} from '../api/api';
import {IChannel} from '../types/types';
import {IRootStore} from './RootStore';

export interface IChannelsStore {
    channels: IChannel[];
    loadChannels: () => void;
    loadChannelsSuccess: (channels: IChannel[]) => void;
    rootStore: IRootStore;
}

class ChannelsStore implements IChannelsStore {
    channels: IChannel[] = [];
    rootStore: IRootStore;

    constructor(rootStore: IRootStore) {
        this.rootStore = rootStore;

        makeAutoObservable(this);
    }

    loadChannels = () => {
        api.getChannels()
            .then(this.loadChannelsSuccess)
            .catch(e => this.rootStore.errorsStore.addError(e));
    }

    loadChannelsSuccess = (channels: IChannel[]) => {
        this.channels = channels;
    }
}

export default ChannelsStore;
